import { render, staticRenderFns } from "./PowerBIPlayground.vue?vue&type=template&id=8f927fb6&"
import script from "./PowerBIPlayground.vue?vue&type=script&lang=js&"
export * from "./PowerBIPlayground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports